import { NEWJOINERDATA } from '../../constants/reducerTypes';

const initialState = [];
const newJoinerReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEWJOINERDATA:
      return action.payload;
    default:
      return state;
  }
};
export default newJoinerReducer;
